import OfficerClient from "../../../api/OfficerClient";
import OfficerAction from "../../../redux/actions/OfficerAction";
import { mapOfficersToOptions, mapToSelect } from "../forms";
import OfficerFormModalAction from "../../../redux/actions/OfficerFormModalAction";

export const searchOfficer = (searchQuery, officerTypeId = 1) => {
  OfficerAction.setLoadingOfficers(true).then(() => {
    OfficerClient.Search({
      badgeNumberOrName: searchQuery,
      officerTypeId: officerTypeId ?? 1,
    })
      .then((response) => {
        const mappedResponse = mapOfficersToOptions(response);
        OfficerAction.dispatch({
          officersOptions: mappedResponse,
        });
      })
      .catch((error) => console.error(error))
      .finally(() => OfficerAction.setLoadingOfficers(false));
  });
};

export const fetchOfficerTypes = () => {
  OfficerFormModalAction.setLoadingOfficerTypes(true)
    .then(() => {
      OfficerClient.MetaData().then((response) => {
        const mappedResponse = mapToSelect(response.officerTypes);
        OfficerFormModalAction.dispatch({ officerTypes: mappedResponse });
      });
    })
    .catch((error) => console.error(error))
    .finally(() => OfficerFormModalAction.setLoadingOfficerTypes(false));
};

export const fetchPoliceId = () => {
  OfficerAction.setLoadingPoliceId(true).then(() => {
    OfficerClient.MetaData()
      .then((response) => {
        const officerTypes = response.officerTypes.filter(
          (x) => x.isPoliceOfficer === true,
        );
        const policeId = officerTypes ? officerTypes[0]?.id : 1;
        OfficerAction.dispatch({
          policeId: policeId,
        });
      })
      .catch((error) => console.error(error))
      .finally(() => OfficerAction.setLoadingOfficers(false));
  });
};
